module.exports = __webpack_public_path__ + "img/icono-10-2.ee9126f6.png";